import React from 'react';
import { csvDownload } from 'react-project/assets/Icons';

export const CsvDownload = ({ onClick, w, h }) => {
  return <div onClick={onClick}>{csvDownload(w, h)}</div>;
};

export default CsvDownload;
